import React, { useEffect, useMemo, useState } from 'react'
import './LoginUserMenu.scss'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import { useSelector } from 'react-redux'
import { CombinedReducers } from 'app_events/index'
import LoginMoodle from '../LoginMoodle/LoginMoodle'
import AuthService from 'app_services/secure/auth/authService'
import { Link } from 'react-router-dom'
import { routingService } from '../../../services/routingService';
import PurchasedItemsService from 'app_services/purchasedItems/purchasedItemsService'
import { PurchasedPlaceStatus } from 'app_types/purchasedItems/purchasedItemsTypes'
import { customs } from 'app_config/globals'

const IconUser = require('app_assets/images/icons/IconUser.png')

const LoginUserMenu = () => {
  const authService = useMemo(() => new AuthService(), [])
  const purchasedItemsService = useMemo(() => new PurchasedItemsService(), [])
  const [hasPendingItems, setHasPendingItems] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const shoppingCartEnabled = customs?.modules?.shoppingCart === 'enabled';

  const userData = useSelector((state: CombinedReducers) => {
    return state.auth.user?.data
  })

  useEffect(() => {
    if (shoppingCartEnabled) {
      checkPendingItems()
    }
  }, [])

  const checkPendingItems = async () => {
    try {
      setIsLoading(true)
      const response = await purchasedItemsService.getPurchasedPlaces()

      if (response.status === "success" && response.purchasedPlaces) {
        // Verificar si hay lugares disponibles (por inscribir)
        const pendingItems = response.purchasedPlaces.some(
          place => place.status === PurchasedPlaceStatus.AVAILABLE
        )
        setHasPendingItems(pendingItems)
      }
    } catch (error) {
      console.error("Error checking pending items:", error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleClickLogout = () => {
    authService.logout()
  }

  return (
    <div className='login-user-menu--container'>
      <div className='login-user-menu--container-user'>
        <img alt='Icono de usuario' src={IconUser}></img>
        <div>
          <p className='login-user-menu--name'>{userData?.profile?.first_name} {userData?.profile?.last_name}</p>
          <p className='login-user-menu--email'>{userData?.email}</p>
        </div>
      </div>
      <div className='login-user-menu--container-button'>
        <LoginMoodle>
          <ButtonComponent
            className='login-user-menu--button-courses'
            variant='tertiary'
          >
            Ir a cursos
          </ButtonComponent>
        </LoginMoodle>
      </div>
      <div className='login-user-menu--container-log-out'>
        <Link to={routingService.getSecurePath()}>
          <ButtonComponent color='#7C878E' fontWeight={400}>
            Mi panel de formación
          </ButtonComponent>
        </Link>
        {shoppingCartEnabled && (
          <Link to={routingService.getSecurePath('/my-products')}>
            <ButtonComponent color='#000104' fontWeight={400} className="products-button">
              Mis Productos {hasPendingItems && !isLoading && <span className='badge badge-info'>Por inscribir</span>}
            </ButtonComponent>
          </Link>
        )}
        <ButtonComponent
          onClick={handleClickLogout}
        >
          Cerrar sesión
        </ButtonComponent>
      </div>
    </div>
  )
}

export default LoginUserMenu